import React from "react";

export default function TableHeadColumn({ tableHeadLable }) {
    return (

        <th>{tableHeadLable}</th>

    )
}